import * as React from "react";
const SvgIcon = (props) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 1.667v16.666m5.893-14.226L4.107 15.892M18.333 10H1.667m14.226 5.893L4.107 4.107"
      stroke="#EDEDED"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcon;
